<ng-container *ngIf="report">
    <app-report-html-to-pdf [report]="report"></app-report-html-to-pdf>
</ng-container>